
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// component modules
import { CoreNotificationsHelpersActionsModule } from './actions/notifications-helpers-actions.module';
import { CoreNotificationsHelpersEventsModule } from './events/notifications-helpers-events.module';

// components

@NgModule({
    imports: [
        CommonModule,
        CoreNotificationsHelpersActionsModule,
        CoreNotificationsHelpersEventsModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        
    ],
    exports: [
      CoreNotificationsHelpersActionsModule,
      CoreNotificationsHelpersEventsModule
    ],

})
export class CoreNotificationsHelpersModule { }
// Module for notification helpers components for each notification
